import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";
import {
  getNotificationsRequest,
  getNotificationsSuccess,
  getNotificationsError,
} from "../../slices/notifications/GetNotificationsSlice";

export const GetNotificationsApi = (status, currentPage = 1, limit = 10) => async (dispatch) => {
  const queryParams = new URLSearchParams({
    status, // 'sent' or 'failed'
    currentPage,
    limit,
  }).toString();

  const url = `${endpoints.NotificationLogs}?${queryParams}`;

  try {
    dispatch(getNotificationsRequest());

    axiosInstance
      .get(url, { headers: { "Content-Type": "application/json" } })
      .then((resp) => {
        dispatch(getNotificationsSuccess(resp?.data));
      })
      .catch((error) => {
        const _error = {
          data: error?.response?.data?.message || error?.message,
          status: error?.response?.status || error?.status,
        };
        dispatch(getNotificationsError(_error));
      });
  } catch (error) {
    dispatch(getNotificationsError({ data: error.message }));
  }
};
